import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {BreadcrumbErrorsFactory} from '../Errors/factory.js'
import BreadcrumbMappersFactory from '../Mappers/factory.js'
import BreadcrumbRepositoriesFactory from '../Repositories/factory.js'

class GetNewsDynamicBreadcrumbsBreadcrumbUseCase extends UseCase {
  #pageConfig
  #repository
  #fromNewsDetailInfoToBreadcrumbRequestValueObjectMapper
  #isNewsDetailPage = pageName => {
    const {NEWS_DETAIL_PAGE_NAME, NEWS_COMMENTS_PAGE_NAME} = this.#pageConfig

    return pageName === NEWS_DETAIL_PAGE_NAME || pageName === NEWS_COMMENTS_PAGE_NAME
  }

  async #getNewsDetailBreadcrumbs({params}) {
    const breadcrumbUrlBuilderRequestValueObject = this.#fromNewsDetailInfoToBreadcrumbRequestValueObjectMapper.map({
      ...params
    })

    const [repositoryError, repositoryResponse] = await this.#repository.getNewsBreadcrumbs({
      breadcrumbUrlBuilderRequestValueObject,
      detailParams: params
    })

    if (repositoryError) return Promise.reject(repositoryError)

    return repositoryResponse.toJSON()
  }

  constructor({pageConfig, repository, fromNewsDetailInfoToBreadcrumbRequestValueObjectMapper}) {
    super()
    this.#pageConfig = pageConfig
    this.#repository = repository
    this.#fromNewsDetailInfoToBreadcrumbRequestValueObjectMapper =
      fromNewsDetailInfoToBreadcrumbRequestValueObjectMapper
  }

  static create({config}) {
    return new GetNewsDynamicBreadcrumbsBreadcrumbUseCase({
      pageConfig: config.get('page'),
      repository: BreadcrumbRepositoriesFactory.httpBreadcrumbRepository({config}),
      fromNewsDetailInfoToBreadcrumbRequestValueObjectMapper:
        BreadcrumbMappersFactory.fromNewsDetailInfoToBreadcrumbRequestValueObjectMapper()
    })
  }

  @tracer({metric: 'GetNewsDynamicBreadcrumbsBreadcrumbUseCase#execute'})
  @AsyncInlineError()
  async execute({pageName, params = {}}) {
    if (this.#isNewsDetailPage(pageName)) {
      return this.#getNewsDetailBreadcrumbs({params})
    }

    return Promise.reject(
      BreadcrumbErrorsFactory.getBreadcrumbs(
        `[GetNewsDynamicBreadcrumbsBreadcrumbUseCase] pageName "${pageName}" is not a valid breadcrumbs news page`
      )
    )
  }
}

export const factory = GetNewsDynamicBreadcrumbsBreadcrumbUseCase.create
